import React from 'react';
import styled from 'styled-components';

const StyledClickableTitle = styled.h4`
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

type TitleProps = {
  name: string;
  href?: string;
  onClick?: () => void;
} & Omit<React.HTMLAttributes<HTMLElement>, 'onClick'>;

export function Title({ name, href, onClick, ...rest }: TitleProps) {
  if (href) {
    return (
      <h4 {...rest}>
        <a href={href}>{name}</a>
      </h4>
    );
  }

  if (onClick) {
    return (
      <StyledClickableTitle onClick={onClick} {...rest}>
        {name}
      </StyledClickableTitle>
    );
  }

  return <h4 {...rest}>{name}</h4>;
}
